/**
 * Describes a DRIVER_UNASSIGN activity: which drivers were removed from the
 * run and who removed them.
 *
 * The removed drivers are the activity's `activity_rescue_drivers`. The person
 * who removed them is `actor_id`/`actor_name`. Rows written before the actor
 * was recorded only have the assignee: since multiple drivers that is the
 * person who removed them, but older rows stored the removed driver there. So
 * the assignee only names the actor when it isn't one of the removed drivers;
 * otherwise `name` is empty because who removed them is unknown.
 *
 * @returns {{ context: 'self' | 'single' | 'many', name: string, drivers: {user_id: number, name: string}[] }}
 */
export function describeDriverUnassign(event) {
  const drivers = Array.isArray(event?.activity_rescue_drivers)
    ? event.activity_rescue_drivers
    : [];
  const actorId = event?.actor_id ?? null;
  const assigneeName = event?.assignee_name || '';
  const legacyActorName =
    actorId == null &&
    assigneeName &&
    !drivers.some((driver) => driver.name === assigneeName)
      ? assigneeName
      : '';
  const isSelf =
    drivers.length === 1 &&
    actorId != null &&
    String(drivers[0].user_id) === String(actorId);

  let context = 'many';
  if (isSelf) {
    context = 'self';
  } else if (drivers.length === 1) {
    context = 'single';
  }

  return {
    context,
    name: event?.actor_name || legacyActorName,
    drivers,
  };
}
